module.exports = __webpack_public_path__ + "img/1.51f80fc9.webp";